// HomePage page component
import { useState, useEffect } from "react";
import {
  Header,
  Footer,
  HeroSection,
  ImpactStats,
  MissionSection,
  StoriesSection,
  DonateSection,
  ContactSection,
} from "../organisms";
import { settingsService } from "../../services/settingsService";
import { LandingContentProvider } from "../../contexts/LandingContentContext";

export const HomePage = () => {
  const [donationEnabled, setDonationEnabled] = useState(true);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const isPreview = params.get("preview") === "1";

    if (isPreview) {
      try {
        const raw = sessionStorage.getItem("landingPreviewDraft");
        if (raw) {
          const draft = JSON.parse(raw);
          if (typeof draft?.donationEnabled === "boolean") {
            setDonationEnabled(draft.donationEnabled);
            return;
          }
        }
      } catch (_) {
        // Fall through to API setting.
      }
    }

    settingsService
      .getDonationEnabled()
      .then((enabled) => setDonationEnabled(enabled !== false))
      .catch(() => {});
  }, []);

  useEffect(() => {
    const scrollToHashTarget = () => {
      const hash = window.location.hash;
      if (!hash) return;
      const targetId = hash.replace("#", "");

      let attempts = 0;
      const maxAttempts = 12;
      const interval = setInterval(() => {
        const el = document.getElementById(targetId);
        attempts += 1;

        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
          clearInterval(interval);
          return;
        }

        if (attempts >= maxAttempts) {
          clearInterval(interval);
        }
      }, 150);
    };

    scrollToHashTarget();
    window.addEventListener("hashchange", scrollToHashTarget);
    return () => window.removeEventListener("hashchange", scrollToHashTarget);
  }, [donationEnabled]);

  return (
    <LandingContentProvider>
      <Header donationEnabled={donationEnabled} />
      <main className="min-h-screen bg-paper font-sans text-ink pt-20">
        <HeroSection donationEnabled={donationEnabled} />
        <ImpactStats />
        <MissionSection />
        <StoriesSection />
        {donationEnabled && <DonateSection />}
        <ContactSection />
      </main>
      <Footer />
    </LandingContentProvider>
  );
};
